const SPOTIFY_POD: string = (window as any)._SPOTIFY_POD_ || 'unknown';

export function getWebsiteOriginPod() {
  return SPOTIFY_POD;
}

export const WEBSITE_ORIGIN_POD_TAG = 'website.origin_pod';
